/**
 * Swaps in Shopify's product recommendations. Port of the related-products
 * half of RelatedAndCategories.tsx.
 *
 * recommendations.products is only populated when the section is requested
 * through the recommendations route, so the section renders a placeholder and
 * fetches its own markup. The wrapper stays hidden until something comes back —
 * React returns null with no recommendations, and a bare heading over an empty
 * grid would look broken.
 */
(function () {
  const el = document.querySelector('[data-cs-related]');
  if (!el || !el.dataset.url) return;
  const wrap = el.closest('[data-cs-related-wrap]');

  fetch(el.dataset.url)
    .then((r) => (r.ok ? r.text() : null))
    .then((html) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = doc.querySelector('.\\!grid');
      if (!grid) return;
      el.innerHTML = grid.outerHTML;
      if (wrap) wrap.hidden = false;
    })
    .catch(() => {});
})();
